import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { Selection as $e40ea825a81a3709$export$52baac22726c72bf } from "./Selection.module.js";
import { useControlledState as $6tM1y$useControlledState } from "@react-stately/utils";
import { useRef as $6tM1y$useRef, useState as $6tM1y$useState, useMemo as $6tM1y$useMemo, useEffect as $6tM1y$useEffect } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $7af3f5b51489e0b5$var$equalSets(setA, setB) {
  if (setA.size !== setB.size) return false;
  var _iterator = _createForOfIteratorHelper(setA),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (!setB.has(item)) return false;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}
function $7af3f5b51489e0b5$export$253fe78d46329472(props) {
  var _props$selectionMode = props.selectionMode,
    selectionMode = _props$selectionMode === void 0 ? 'none' : _props$selectionMode,
    _props$disallowEmptyS = props.disallowEmptySelection,
    disallowEmptySelection = _props$disallowEmptyS === void 0 ? false : _props$disallowEmptyS,
    allowDuplicateSelectionEvents = props.allowDuplicateSelectionEvents,
    _props$selectionBehav = props.selectionBehavior,
    selectionBehaviorProp = _props$selectionBehav === void 0 ? 'toggle' : _props$selectionBehav,
    _props$disabledBehavi = props.disabledBehavior,
    disabledBehavior = _props$disabledBehavi === void 0 ? 'all' : _props$disabledBehavi; // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
  // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
  var isFocusedRef = (0, $6tM1y$useRef)(false);
  var _ref = (0, $6tM1y$useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    _setFocused = _ref2[1];
  var focusedKeyRef = (0, $6tM1y$useRef)(null);
  var childFocusStrategyRef = (0, $6tM1y$useRef)(null);
  var _ref3 = (0, $6tM1y$useState)(null),
    _ref4 = _slicedToArray(_ref3, 2),
    _setFocusedKey = _ref4[1];
  var selectedKeysProp = (0, $6tM1y$useMemo)(function () {
    return $7af3f5b51489e0b5$var$convertSelection(props.selectedKeys);
  }, [props.selectedKeys]);
  var defaultSelectedKeys = (0, $6tM1y$useMemo)(function () {
    return $7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new (0, $e40ea825a81a3709$export$52baac22726c72bf)());
  }, [props.defaultSelectedKeys]);
  var _ref5 = (0, $6tM1y$useControlledState)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange),
    _ref6 = _slicedToArray(_ref5, 2),
    selectedKeys = _ref6[0],
    _setSelectedKeys = _ref6[1];
  var disabledKeysProp = (0, $6tM1y$useMemo)(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);
  var _ref7 = (0, $6tM1y$useState)(selectionBehaviorProp),
    _ref8 = _slicedToArray(_ref7, 2),
    selectionBehavior = _ref8[0],
    setSelectionBehavior = _ref8[1]; // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
  // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
  if (selectionBehaviorProp === 'replace' && selectionBehavior === 'toggle' && typeof selectedKeys === 'object' && selectedKeys.size === 0) setSelectionBehavior('replace');
  // If the selectionBehavior prop changes, update the state as well.
  var lastSelectionBehavior = (0, $6tM1y$useRef)(selectionBehaviorProp);
  (0, $6tM1y$useEffect)(function () {
    if (selectionBehaviorProp !== lastSelectionBehavior.current) {
      setSelectionBehavior(selectionBehaviorProp);
      lastSelectionBehavior.current = selectionBehaviorProp;
    }
  }, [selectionBehaviorProp]);
  return {
    selectionMode: selectionMode,
    disallowEmptySelection: disallowEmptySelection,
    selectionBehavior: selectionBehavior,
    setSelectionBehavior: setSelectionBehavior,
    get isFocused() {
      return isFocusedRef.current;
    },
    setFocused: function setFocused(f) {
      isFocusedRef.current = f;
      _setFocused(f);
    },
    get focusedKey() {
      return focusedKeyRef.current;
    },
    get childFocusStrategy() {
      return childFocusStrategyRef.current;
    },
    setFocusedKey: function setFocusedKey(k) {
      var childFocusStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'first';
      focusedKeyRef.current = k;
      childFocusStrategyRef.current = childFocusStrategy;
      _setFocusedKey(k);
    },
    selectedKeys: selectedKeys,
    setSelectedKeys: function setSelectedKeys(keys) {
      if (allowDuplicateSelectionEvents || !$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) _setSelectedKeys(keys);
    },
    disabledKeys: disabledKeysProp,
    disabledBehavior: disabledBehavior
  };
}
function $7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
  if (!selection) return defaultValue;
  return selection === 'all' ? 'all' : new (0, $e40ea825a81a3709$export$52baac22726c72bf)(selection);
}
export { $7af3f5b51489e0b5$export$253fe78d46329472 as useMultipleSelectionState };